export default {
	sec_10: {
		title: {
			one: '입금 ',
			two: '받기',
		},
		desc: {
			one: 'JP WORLD PAY에서 편리하게 입금을 받으세요.',
		},
		btn: {
			one: '자산보내기',
			two: '앱 다운로드',
		},
	},
	sec_11: {
		title: {
			one: '가장 편리한 입금',
		},
		desc: {
			one: '상대방 이메일로 보내면 끝',
		},
	},
	sec_04: {
		title: '받는 사람에게 표시되는 것',
		cards: {
			one: {
				title: {
					one: 'JP WORLD PAY와',
					two: 'JP WORLD PAY 간의 송금',
				},
				description: {
					one: 'JP WORLD PAY에서',
					two: 'JP WORLD PAY로 송금 시 ',
					three: '사용되는 계좌번호가 노출됩니다.',
				},
			},
			two: {
				title: {
					one: '외부에서',
					two: 'JP WORLD PAY로 입금',
				},
				description: {
					one: '외부에서 JP WORLD PAY로 입금 시',
					two: '사용되는 지갑 주소가',
					three: '노출됩니다.',
				},
			},
		},
	},
};
